// Rotas do módulo de Políticas

import FullLayout from '@/layouts/full/FullLayout.vue';
import type { RouteRecordRaw } from 'vue-router';

const policiesRoutes: RouteRecordRaw[] = [
    {
        path: '/policies',
        component: FullLayout,
        meta: {
            requiresAuth: true,
            title: 'Políticas - Hub'
        },
        children: [
            {
                path: '',
                name: 'policies-navigation',
                component: () => import('@/views/Policies/PoliciesNavigation.vue'),
                meta: { title: 'Políticas', breadcrumb: 'Políticas' }
            },
            {
                path: 'dashboard',
                name: 'policies-dashboard',
                component: () => import('@/views/Policies/PoliciesDashboard.vue'),
                meta: { title: 'Dashboard de políticas', breadcrumb: 'Dashboard' }
            },
            {
                path: 'admin/categories',
                name: 'policies-admin-categories',
                component: () => import('@/views/Policies/PoliciesCategoriesAdmin.vue'),
                meta: { title: 'Categorias de políticas', breadcrumb: 'Categorias' }
            },
            {
                path: 'admin',
                name: 'policies-admin',
                component: () => import('@/views/Policies/PoliciesAdmin.vue'),
                meta: { title: 'Administração de políticas', breadcrumb: 'Admin' }
            },
            {
                path: 'new',
                name: 'policies-new',
                component: () => import('@/views/Policies/PoliciesNew.vue'),
                meta: { title: 'Nova política', breadcrumb: 'Nova política' }
            },
            {
                path: 'edit/:id(\\d+)',
                name: 'policies-edit',
                component: () => import('@/views/Policies/PoliciesEdit.vue'),
                props: true,
                meta: { title: 'Editar política', breadcrumb: 'Editar política' }
            },
            {
                path: ':id(\\d+)',
                name: 'policies-reading',
                component: () => import('@/views/Policies/PolicyReading.vue'),
                props: true,
                meta: { title: 'Leitura de política', breadcrumb: 'Leitura' }
            }
        ]
    }
];

export default policiesRoutes;
